import React from 'react'
import ContentAreaContainer from '../../@c_containers/content_area/content_area.container'

const ContentAreaTemplate = function ({...props}) {
  return <ContentAreaContainer {...props} />
}

export default ContentAreaTemplate
